
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import { ItemModel } from '~/types/ItemModel'

@Component
export default class extends Vue {
  @Prop() itemModel!: ItemModel
  @Prop() itemType!: 'small' | 'medium' | 'large'
  @Prop() rateRange!: number
  @Prop() isArtist!: boolean
}
